<template>
<div class="schedule" 
    @dragover="disableDragendAnimation"
>

<DialogMonshinnaiyou ref="monshinDialog" :is_showBtn="false" @submit_monshin="submit_monshin"></DialogMonshinnaiyou>
<DialogSyochinaiyou  ref="syochiDialog" :is_showBtn="false" @submit_syochi="submit_syochi"></DialogSyochinaiyou>

        <div class="sc-main-scroll">
          <div class="sc-main">

<v-container
    :style="{'max-width': (settingData.unitDivW+1)*7+64*2+ 'px !important'}"
>
<!-- 日付 -->
<v-row
    :class="{'mygreen':is_today, 'not_today':!is_today, 'text-center':true, 'white--text':true , 'clickable':kobetu_mode}"
    :style="{'max-width': (settingData.unitDivW+1)*7+64*2+ 'px !important'}"
    @click="header_click()"
>
    <v-col>{{ date_text }}</v-col>
    <!-- <v-col>test</v-col> -->
</v-row>


<!-- ヘッダー -->
<v-row class="scheader"
    :style="{'max-width': (settingData.unitDivW+1)*7+64*2+ 'px !important'}"
>
  <div style="width: 64px; border-right:1px solid LightGray;"></div>
  <div
    v-for="(title, index) in ['UNIT1', 'UNIT2', 'UNIT3', 'UNIT4', 'UNIT5', 'UNITA', 'UNITB']"
    :key="index"
    :style="{'width':settingData.unitDivW + 1 + 'px', 'line-height': '40px'}"
    :class="['text-center', 'align-self-center', 'unit_title', kobetu_mode ? 'clickable':'']"
    @click="unit_click(index)"
  >{{title}}
  </div>
  <div style="width: 64px;"></div>
</v-row>



<!-- カレンダー -->
<v-row>
  <!-- 時間軸 左側 -->
  <div class="timeline jikanjiku">
    <div
      v-for="n in 24"
      :key="n"
      :class="['sc-time', (n<=9 || n>=20) ? 'disp_none': '']"
      :style="{width: '64px'}"
    >{{ getHeaderTime(n - 1) }}:00<span :class="['left_timeline', (n==10) ? 'left_toptimeline':'']"></span></div>
  </div>


  <!-- UNIT 1個分 -->
  <div
    v-for="(row, index) in scheduleData"
    :key="index"
    :class="'timeline oneunit'"
    @dragenter="setDragenterRow(index)"
  >
    <!-- 1個分のマス目 -->
    <unitDiv
      v-for="n in unitCnt"
      :data-masu="index+':'+n"
      :data-unit="index"
      :width="settingData.unitDivW + 'px'"
      :height="settingData.dateDivH + 'px'"
      :arr_holiday="arr_holiday"
      :arr_unit="arr_unit"
      :key="'unit' + n"
      :row-index="index"
      :key-index="n"
      :row-data="row"
      :is-business="true || isBusiness(index, (n - 1))"
      :is-selecting="isSelecting"
      :is-selecting-row-index="isSelectingRowIndex"
      :is_contextmenu="is_contextmenu"
      @mouse-move="doDrag"
      @mouse-down="startDrag"
      @mouse-enter="adjustTimeRange"
      @mouse-up="selectEndTime"
      @close_contextmenu="closeContextMenu"
      @set-dragenter-row-and-index="setDragenterRowAndIndex"
    ></unitDiv>

    <!-- 1個分のイベント  -->
    <reservedDiv
      v-for="(detail, keyNo) in row.schedule"
      :unit-width="settingData.unitDivW"
      :unit-height="settingData.dateDivH"
      :key="'res' + keyNo"
      :schedule-detail="detail"
      :row-index="index"
      :row="detail"
      :key-no="keyNo"
      :start-text="detail.start"
      :end-text="detail.end"
      :title-div-width="settingData.titleDivW"
      :border-width="settingData.borderW"
      :min-date="settingData.startDate"
      :max-date="settingData.endDate"
      :unit="settingData.unit"
      :clear-switch="clearSwitch"
      :dragenter-row-index="dragenterRowIndex"
      :dragenter-key-index="dragenterKeyIndex"
      :is-selecting="isSelecting"
      :is-selecting-row-index="isSelectingRowIndex"
      :is-selecting-index="isSelectingIndex"
      @set-dragenter-row-and-index="setDragenterRowAndIndex"
      @move-schedule-data="moveScheduleData"
      @edit-schedule-data="editScheduleData"
      @move-event="$emit('move-event')"
      @edit-event="$emit('edit-event', detail.start, detail.end)"
      @click-event="$emit('click-event', detail.start, detail.end, detail.text, detail.id)"
      @context-menu="$emit('context-menu', detail.id, index, $event)"
      @show-monshin="showMonshin"
      @show-syochi="showSyochi(detail.id, index)"
      @get-yoyaku="getYoyaku"
    >
    </reserveddiv>
  </div>


  <!-- 時間軸 右側-->
  <div class="timeline jikanjiku">
    <div
      v-for="n in 24"
      :key="n"
      :class="['sc-time', 'sc-time-right', (n<=9 || n>=20) ? 'disp_none': '']"
      :style="{width: '64px'}"
    >{{ getHeaderTime(n - 1) }}:00<span :class="['right_timeline', (n==10) ? 'right_toptimeline':'']"></span></div>
  </div>

</v-row>
</v-container>


          </div>
        </div>
      <br class="clear" />


</div>

</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import DialogMonshinnaiyou from '@/components/DialogMonshinnaiyou.vue';
import DialogSyochinaiyou from '@/components/DialogSyochinaiyou.vue';
import axios from 'axios';
import {mapGetters} from 'vuex';
import moment from 'moment';
/* eslint-disable */


const unitDiv = {
  template: `
        <div
          :class="['masu', isUntouchable(rowIndex) ? 'untouchable':'', isGray(rowIndex,keyIndex)? 'gray':'', 'tl', isBusiness ? 'can-res' : 'cant-res', keyIndex<=36 ? 'disp_none': '', keyIndex%4===0 ? 'bBottom':'', keyIndex%2===0 ? 'bBottom_s':'']"
          :style="{width: width, height: height}"
          @mousedown.left="mousedown($event, rowIndex, keyIndex)"
          @mouseenter="mouseenter"
          @mouseup.left="mouseup(rowIndex, keyIndex)"
          @mouseup.right="mouseupRight()"
          @mousemove="mousemove($event, rowIndex, keyIndex)"
          @dragenter="setDragenterRowAndIndex"
        >
        <!--{{rowIndex}}: {{keyIndex}}-->
        </div>
    `,
  props: {
    kobetu_mode: Boolean,
    is_contextmenu: Boolean,
    rowIndex: Number,
    keyIndex: Number,
    width: String,
    height: String,
    rowData: Object,
    isBusiness: Boolean,
    isSelecting: Boolean,
    isSelectingRowIndex: Number,
    arr_holiday: Object,
    arr_unit: Array,
  },

    created() {
        console.log('%ccreated: SchedulerLite.vue', mycolor.purple);
    },

  data: function() {
    return {
    };
  },
  watch: {
  },
  mounted(){
    console.log('unitDiv: mounted()');
  },
  methods: {
    isGray(k,v) {
      // 非営業日のグレーアウト
      return this.arr_holiday[k].indexOf(v)!==-1 ? true : false;
    },
    isUntouchable(k) {
      // 非営業日のグレーアウト
      return this.arr_unit.indexOf(k)!==-1 ? true : false;
    },


    /* eslint-disable */
    mousedown() {
      console.log('unitDiv: mousedown()');

      // コンテキストメニューが開いていたら閉じる
      console.log(this.is_contextmenu)
      if(this.is_contextmenu){
          return false;
      }


      this.$emit("mouse-down", this.rowIndex, this.keyIndex);
      return false;  // todo: マスクリック無効化しときました.

      /*
      if (!this.isBusiness) {
        return false;
      }
      this.$emit("mouse-down", event, this.rowIndex, this.keyIndex);
      */
    },

    mouseup(unitno, masuno) {
      console.log('unitDiv: mouseup()');
      console.log(this.is_contextmenu)
      // コンテキストメニューが開いていたら閉じる
      if(this.is_contextmenu){
          return false;
      }

      this.$emit("mouse-up", unitno, masuno);
    },

    mouseupRight(unitno, masuno) {
      console.log('unitDiv: mouseupRight()');
      console.log(this.is_contextmenu)
      // コンテキストメニューが開いていたら閉じる
      if(this.is_contextmenu){
          this.$emit('close_contextmenu');
          return false;
      }
    },

    mouseenter() {
//      console.log('unitDiv: mouseenter()');
      if (
        !this.isSelecting ||
        this.rowIndex != this.isSelectingRowIndex ||
        !this.isBusiness
      ) {
        return false;
      }
      this.$emit("mouse-enter", this.keyIndex);
    },
    mousemove(event, unitno, masuno) {
//      console.log('unitDiv: mousemove()');
      this.$emit("mouse-move", event, unitno, masuno);
    },
    setDragenterRowAndIndex() {
//      console.log('unitDiv: setDragenterRowAndIndex()');
      if (!this.isBusiness) {
        return false;
      }
      // UNIT番号とインデックスを親に中継してるだけ.
      this.$emit("set-dragenter-row-and-index", this.rowIndex, this.keyIndex);
    }
  },
};  // unitDiv




const reservedDiv = {
  template: `
        <div
          v-if="isShow"
          :class="{'sc-bar': true, 'is_past': is_past, 'is_red': is_red}"
          :style="styleObject"
          :draggable="'true'"
          @dragstart="moveStart"
          @dragend="moveEnd"
          @dragover="editting($event)"
          @mouseup="mouseup"
          @mousemove="mousemove"
          @click.left.stop="$emit('click-event')"
          @click.right.prevent.stop="showContextMenu($event)"
        >
            <div class="icon_block">
                <img v-if="row.is_syosin" class="img" src="/img/icon_syosin.svg" width="14px" style="font-size: 11px;" />
                <img v-if="row.is_memo" @click.prevent.stop="show_memo" class="img" src="/img/icon_memo.svg" width="14px" style="margin-left: -2px;" />
                <img @click.prevent.stop="showMonshin" class="img" src="/img/icon_monsin.svg" onmouseover="this.classList.add('icon_filter')"  onmouseout="this.classList.remove('icon_filter')" width="14px" style="margin-left: -2px; margin-right: -2px; z-index: 300; position: relative;" />
            </div>

              <div v-if="row.patient_id" class="text" style="min-height:16px;line-height:26px;">
                      <a @click.prevent.stop="toPatientDetail(row)" class="patient_name" title="row.patient_name">{{ row.omit_patient_name ? row.omit_patient_name : row.patient_name }}</a>
              </div>
              <div v-else class="text" style="min-height:16px;line-height:26px;">
                      <div @mouseover="showTooltip('name-'+row.id)" @mouseleave="hiddenTooltip('name-'+row.id)"  class="tooltip-container">
                      <p :id=" 'name-'+ row.id" class="tooltip-text">{{ row.patient_name }}</p>
                      <span>{{ row.omit_patient_name ? row.omit_patient_name : row.patient_name }}</span>
                      </div>
              </div>

          <div class="text syochi_oya"><span @click.prevent.stop="showSyochi()" class="syochi" v-html="syochi_text"></span></div>
          <div class="text" v-html="doctor_text"></div>
          <div
            class="resizable-e"
            :draggable="'true'"
            @dragstart="editStart"
            @dragend="editEnd"
          ></div>
        </div>
    `,
  props: {  // reservedDiv
    rowIndex: Number,
    keyNo: Number,
    unitWidth: Number,
    unitHeight: Number,
    titleDivWidth: Number,
    borderWidth: Number,
    startText: String,
    endText: String,
    minDate: String,
    maxDate: String,
    unit: Number,
    clearSwitch: Boolean,
    dragenterRowIndex: Number,
    dragenterKeyIndex: Number,
    isSelecting: Boolean,
    isSelectingRowIndex: Number,
    isSelectingIndex: Number,
    row: Object,
    colors: '#000',
  },
  data: function() {  // reservedDiv datas
    return {
      styleObject: {
        background: this.row.back_color,
        Opacity: 1,
        left: "0px",
        width: "0px",
        height: "130px",
        borderLeft: "4px solid "+this.row.doctor_color,
        "border-radius": "6px",
        "z-index": 0,
        overflow: "hidden"
      },
      isShow: false,
      mouseXStarted: null,
      mouseYStarted: null,
      startLineNo: null,
      endLineNo: null,
      isEdit: false,
      isMove: false,
    };
  },
  computed: {
    /* eslint-disable */
    ...mapGetters(['user', 'user_name', 'is_admin']),


    is_past: function () {
        // 過去のチップはグレーにする
        let mydate = moment(this.row.end);
        let currentDate = moment();

        console.group();
        console.log('%c %s', mycolor.strong, 'is_past');
        console.log(this.row);
        console.log(mydate);
        console.groupEnd();

        if( mydate.isBefore(currentDate) ){
            return true;
        }else{
            return false;
        }
    },

    is_red: function () {
        // 受付ステータスから30分経過は赤にする
        let mydate = moment(this.row.updated_at);
        mydate.add(1*15, 'minutes');    // 15分後
        let currentDate = moment();

        console.group();
        console.log('%c %s', mycolor.strong, 'is_red');
        console.log(this.row);
        console.log(mydate);
        console.groupEnd();

        let that = this;
        setTimeout( function(){
            that.$emit('get-yoyaku');
        }, 1000*60*15 );   // 15分後

        if( mydate.isBefore(currentDate) && this.row.status==='受付' ){
            return true;
        }else{
            return false;
        }
    },

    syochi_text: function () {
      let diff = (Date.parse(this.row.end) - Date.parse(this.row.start)) / (1000*60);
      // 日本語で何文字か
      let syochi_text = this.row.syochi_text;
//      syochi_text = "あいうえおかきくけこさしすせそたちすてとなにぬねのはひふへほまみむめもあいうえおかきくけこ"
//      syochi_text = "あいうえおかきくけこさしすせそたちすてとなにぬねのはひふへほまみむめもあ"
//      syochi_text = "あいうえおかきくけこさしすせそたちすてとなにぬね"
      let len_syochi_text = Math.floor( syochi_text.bytes()/2 );

      // 1行に日本語12文字入る.
//      let max = Math.floor( diff/15 )*12;
//      max = len_syochi_text<=max ? len_syochi_text : max;
//      console.log('diff', diff);
//      console.log('len_syochi_text', len_syochi_text);
//      console.log('max', max);


          if(diff<=30){
              syochi_text = syochi_text.slice(0, 12);
          }else{
              syochi_text = syochi_text.slice(0, 20);
          }

/*
      if(len_syochi_text>max){
          syochi_text = syochi_text.slice(0, max-1)+'…';
      }else{
          syochi_text = syochi_text.slice(0, max);
      }
      */

      return syochi_text;
    },
    doctor_text: function () {
      return this.row.doctor_text.replace(/\n/mg, '<br>');
    },
  },  // computed

  created() {  // reservedDiv イベントを作って配置
    console.log('----------\n');
    console.group();
    console.log('%c %s', mycolor.created, 'reservedDiv: created()');
    console.log(this.styleObject);
    console.log( this.row.unit, this.row.id);
    console.groupEnd();

    if (
      new Date(this.startText) - new Date(this.minDate) < 0 &&
      new Date(this.endText) - new Date(this.minDate) < 0
    ) {
      return;
    }
    this.setTopPosition();
    this.setWidth();
    this.isShow = true;



  },
  watch: {   // reservedDiv
    startText(newVal, oldVal) {
      if (newVal != oldVal) {
        this.startDate = newVal;
        this.setTopPosition();
      }
    },
    endText(newVal, oldVal) {
      if (newVal != oldVal) {
        this.endDate = newVal;
        this.setWidth();
        if (
          this.isSelecting &&
          this.mouseXStarted &&
          this.rowIndex == this.isSelectingRowIndex &&
          this.keyNo == this.isSelectingIndex
        ) {
          let diff = this.getMinutesDiff(new Date(oldVal), new Date(newVal));
          let cnt = parseInt(diff / this.unit);
          this.mouseXStarted += this.unitWidth * cnt;
        }
      }
    },
    dragenterKeyIndex(newVal, oldVal) {
        // this.editting() を呼び出すかどうか判断
      if (
        newVal != oldVal &&
        this.dragenterRowIndex == this.rowIndex &&
        this.isEdit
      ) {
        this.editting();
      }
    },
    clearSwitch(newVal, oldVal) {
      if (newVal != oldVal) {
        this.editEnd();
      }
    }
  },
  methods: { // reservedDiv
    showTooltip(target){
        console.log('%c showTooltip(%s)', mycolor.strong, target);
        let ele = document.getElementById(target);
        console.log('%c ele: %s', mycolor.strong, ele);
        if(ele){
            ele.style.display = 'block';
        }
    },
    hiddenTooltip(target){
        console.log('%c hiddenTooltip(%s)', mycolor.strong, target);
        let ele = document.getElementById(target);
        console.log('%c ele: %s', mycolor.strong, ele);
        if(ele){
            ele.style.display = 'none';
        }
    },
    toPatientDetail(row){
        console.log('toPatientDetail');
        console.log(row);
        var api = '/patient/'+row.patient_id;
        this.$router.push(api).catch(()=>{});
    },
    showSyochi() {
      // ただ上に伝搬
      this.$emit('show-syochi');
    },
    showMonshin() {
      // ただ上に伝搬
      this.$emit('show-monshin', this.row.id);
    },
    showContextMenu(e){
        this.$emit('context-menu', e);
    },
    doSomething:function(){
      alert('click');
    },
    /**
     * Set the Block left pixel
     *
     * @returns void
     */
    setTopPosition() {
      console.log('----------\n');
      console.log('setTopPosition()');
      console.log('this.minDate: ', this.minDate);
      console.log('イベントの開始時刻: ', this.startText);
      let leftDiff = this.getMinutesDiff(
        new Date(this.minDate),    // settingData.startDate '2020/05/06'
        new Date(this.startText)   // detail.start  '2022/05/06 10:00'  イベントの開始時刻
      );
      //=> 600 10時間分を示唆 1マスの単位を15分と決めたから何マス分 オフセットがあるか決める
      // leftDiff / this.unit  600/15=40  0時スタートから考えたときに 40マス分 offsetある.
      let offset = parseInt(leftDiff / this.unit) - 36;  // 9:00から開始させるために
      this.startLineNo = offset;
      console.log('startLineNo: '+offset+'マス分');
      let shiftTop = this.unitHeight * offset;
      this.styleObject.top = shiftTop + "px";
    },
    /**
     * Set the Block width pixel
     *
     * @returns void
     */
    setWidth() {
      console.log('reservedDiv: setWidth()');
      console.log('startText: ', this.startText);
      console.log('endText: ', this.endText);
      let rightDiff = this.getMinutesDiff(
        new Date(this.startText),
        new Date(this.endText)
      );
      let widthCnt = parseInt(rightDiff / this.unit);
      this.endLineNo = this.startLineNo + widthCnt;
//      let width = this.unitWidth * widthCnt + widthCnt * this.borderWidth;
//      let width = this.unitHeight * widthCnt + widthCnt * this.borderWidth;
      let width = this.unitHeight * widthCnt;
      console.log('widthCnt: '+widthCnt+'マス分')
      console.log('width: ', width);
      this.styleObject.width = ( this.unitWidth -5 ) + "px";
      this.styleObject.height = ( width - 5 ) + "px";
    },
    /**
     * Set the Block to edit status
     *
     * @param Object e Event
     *
     * @returns void
     */
    editStart(e) {
      if (this.isSelecting) {
        e.preventDefault();
        return;
      }
      this.isEdit = true;
      this.mouseXStarted = e.clientX;
      this.styleObject.Opacity = 0.5;
    },
    /**
     * Adjust time event
     *
     * @param Obejct e Event
     *
     * @returns void
     */
    editting(e) {
      if (this.isSelecting) {
        e.preventDefault();
        return;
      }
      if (this.isEdit) {
        if (e) {
          let width = e.x + e.layerX
          if (this.mouseXStarted > width) {
            this.mouseXStarted = width
            return;
          }

          // adjust by Mouse X-axio
          let movePx = e.clientX - this.mouseXStarted;
          let unitCnt = parseInt(movePx / this.unitWidth);
          if (unitCnt != 0) {
            this.mouseXStarted = e.clientX;
            this.$emit(
              "edit-schedule-data",
              this.rowIndex,
              this.keyNo,
              unitCnt
            );
          }
        } else {
          // adjust by current unit-div number
          if (this.dragenterKeyIndex > this.startLineNo) {
            this.mouseXStarted += this.unitWidth;
            let unitCnt = parseInt(this.dragenterKeyIndex - this.endLineNo);
            this.$emit(
              "edit-schedule-data",
              this.rowIndex,
              this.keyNo,
              unitCnt
            );
          }
        }
      }
    },
    /**
     * End edit and set new data
     *
     * @returns void
     */
    editEnd() {
      if (this.isEdit) {
        this.$emit("edit-event", this.startText, this.endText);
      }
      this.isEdit = false;
      this.styleObject.Opacity = 1;
      this.mouseXStarted = null;
    },
    /**
     * Set the block to move status
     *
     * @param Object e
     */
    moveStart(e) {
      console.log('----------\n');
      console.log('reservedDiv: move--------------------------------------------------Start()');

      if (this.isSelecting) {
        e.preventDefault();
        return;
      }
      if (!this.isEdit) {
        this.styleObject.Opacity = 0.5;
        this.isMove = true;
        this.mouseXStarted = e.clientX;
        this.mouseYStarted = e.clientY;
        this.$emit("set-dragenter-row-and-index", this.rowIndex, null);
      }
    },
    /**
     * End move and set new data
     *
     * @returns void
     */
    moveEnd(e) {
      console.log('----------\nreservedDiv: moveEnd()');

      let mouseYEnd = e.clientY;

      console.log('this.isMove', this.isMove);
      console.log('this.mouseYStarted', this.mouseYStarted);
      console.log('mouseYEnd', mouseYEnd);
      console.log('this.dragenterRowIndex', this.dragenterRowIndex);  // 移動先
      console.log('this.rowIndex', this.rowIndex);                    // 移動元

      // Check move status and move block
      if (
        this.isMove &&
        (mouseYEnd != this.mouseYStarted ||
          this.dragenterRowIndex != this.rowIndex)
      ) {

          // get x-axis moved count
          let moveXPx = mouseYEnd - this.mouseYStarted;      // スタート位置からどのくらい動いたかどうか
          let unitCnt = parseInt(moveXPx / this.unitHeight);  // 何マス分動いたか
          let halfWidth = parseInt(this.unitHeight / 2);
          let modXPx = parseInt(moveXPx % this.unitHeight);   // この値は必ず1マス分より小さい値になることを利用


          console.log('moveXPx', moveXPx);
          console.log('unitCnt', unitCnt);
          console.log('halfWidth', halfWidth);
          console.log('modXPx', modXPx);
          console.log('this.unitHeight', this.unitHeight);  // 1マス分の広さ



          // ←移動に関してはマスの半分を超えたら繰り上げ、→方向に関しては確実に線を越えたら移動という考え
          if (moveXPx < 0 && Math.abs(modXPx) >= halfWidth) {
            unitCnt--;
          }
          this.mouseYStarted = null;

          if (unitCnt != 0 || this.dragenterRowIndex != this.rowIndex) {
            // result pass to father component's method
            // moveScheduleDataを呼んでる
            // パラメータ: UNIT番号, UNITの中のindex, unitCnt, 左1マスが-1, 右に1マス分が1
            this.$emit("move-schedule-data", this.rowIndex, this.keyNo, unitCnt);
          }
      }

      // Return block all status and opacity
      this.isEdit = false;
      this.isMove = false;
      this.styleObject.Opacity = 1;
    },
    /**
     * Mouse move event for Add new schedule
     */
    mousemove(e) {
      console.log('----------\nmousemove(e)');
      if (
        this.rowIndex == this.isSelectingRowIndex &&
        this.keyNo == this.isSelectingIndex
      ) {
        if (this.isSelecting && this.mouseXStarted) {
          let movePx = e.clientX - this.mouseXStarted;
          let unitCnt = parseInt(movePx / this.unitWidth);
          if (unitCnt != 0 && unitCnt < 0) {
            this.mouseXStarted = e.clientX + this.unitWidth;
            this.$emit(
              "edit-schedule-data",
              this.rowIndex,
              this.keyNo,
              unitCnt
            );
          }
        }
        if (this.isSelecting && !this.mouseXStarted) {
          this.mouseXStarted = e.clientX;
          this.styleObject.Opacity = 0.5;
        }
      }
    },
    /**
     * Mouse up event for Add new schedule
     */
    mouseup() {
      console.log('reservedDiv: mouseup()');
      console.log('startText: ', this.startText);
      console.log('endText: ', this.endText);
      this.$emit("mouse-up", this.startText, this.endText);
    },
    // 2つの日付の差(分)
    // 1回目は左端の位置を求めるため、
    // 2回目はwidthを求めるために呼ばれる.
    getMinutesDiff(date1, date2) {
      const diffTime = date2 - date1;
      let ret = Math.ceil(diffTime / (1000 * 60));
//      console.log('----------\n');
//      console.log('reservedDiv: getMinutesDiff()');
//      console.log(ret+'分');  // 分

      return ret
    }
  },
};  // reservedDiv





// 以下 componentsのexport
export default {
  name: "vue-scheduler-lite",
  components: {
    "unitDiv": unitDiv,
    "reservedDiv": reservedDiv,
    DialogMonshinnaiyou,DialogSyochinaiyou,
  },
  props: {
    stop_dialog: Boolean,
    scheduleData: Array,
    setting: Object,
    kobetu_mode: Boolean,
    is_contextmenu: Boolean,
    arr_holiday: Object,
    arr_unit: Array,
  },
  data() {  // components datas
    return {
      is_today: true,
      all_gray: false,  // 日付をクリックしたときのフラグ
      dragging: false,
      drag_target: '',
      x: 'no',
      y: 'no',
      date_text: this.setting.startDate,
      settingData: this.setting,
      padding: 0,
      timeDivW: 0,
      dateDivW: 0,
      contentH: 0,
      contentW: 0,
      unitCnt: 0,
      isSelecting: false,
      isSelectingRowIndex: null,
      isSelectingIndex: null,
      dragenterRowIndex: null,
      dragenterKeyIndex: null,
      clearSwitch: false
    };
  },

  mounted(){
      // マスとイベントのDOM描画が終わった状態
      console.log('----------\n');
      console.log('components: mounted()');
      window.addEventListener('mouseup', this.stopDrag);
  },
  updated(){
//      console.log('----------\n');
//      console.log('components: updated()');

  },
  created() {  // components
    console.log('%c created()', 'background: purple;');
    console.log(this.settingData.startDate);

    //当日だけmygreenにする.  todo: 変数名ちゃんとしたい
    var today = new Date();
    let re = /(\d+)-(\d+)-(\d+)/;
    var today_text = today.toISOString().toString().substring(0,10);
    today_text = today_text.replace(re, '$1/$2/$3');
    console.log('startDate', this.settingData.startDate);
    console.log('today_text', today_text);
    if(this.settingData.startDate===today_text){
        this.is_today = true;
    }else{
        this.is_today = false;
    }


    String.prototype.bytes = function () {
      var length = 0;
      for (var i = 0; i < this.length; i++) {
        var c = this.charCodeAt(i);
        if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
          length += 1;
        } else {
          length += 2;
        }
      }
      return length;
    };

    console.log('----------\n');
    console.log('components: created() todo: 再描画で2回呼ばれるのはいかがなものか');

    let weekday = new Date(this.date_text).getDay();
    this.date_text += ' (' + this.settingData.weekdayText[weekday] + ')'
    this.date_text = this.date_text.replace(/^\d{4}-/mg, '').replace('-', '/');
    console.log(this.date_text);

    this.settingData = Object.assign(this.settingData, this.setting);


    // 1日のマスの数  1UNIT分は96マス 1440/60=24 割る数を小さくすればマスを増やせる.
    // 9時以前のマスは disp_none で非表示に
//    let oneDayCnt = parseInt(1440 / this.settingData.unit);
    let oneDayCnt = 76;  // 15分刻みで 37~76 で1UNIT 40枠ある

    // 1UNITのマスの数
    console.log('1UNITのマスの数');
    this.unitCnt = oneDayCnt;
    this.padding =
      this.settingData.dateDivH +
      this.settingData.timeDivH +
      this.settingData.borderW * 4;
    this.dateDivW =
      this.settingData.unitDivW * oneDayCnt +
      (oneDayCnt - this.settingData.borderW);
    this.contentH =
      this.padding +
      (this.settingData.rowH + this.settingData.borderW * 2) *
        this.scheduleData.length;
    this.contentW =
      this.dateDivW  + this.settingData.borderW;
    this.timeDivW =
      (60 / this.settingData.unit) *
        (this.settingData.unitDivW + this.settingData.borderW) -
      1;
  },

  methods: {  // components 712~1303
    closeContextMenu(){
        // ただ上に伝搬
        this.$emit('close_contextmenu');
        console.log('%c %s', mycolor.strong, 'component: closeContextMenu()');
    },
    getYoyaku() {
      console.log('%c %s', mycolor.strong, 'components: getYoyaku()');
      // ただ上に伝搬
      this.$emit('get_yoyaku');
    },
    header_click(){
        console.log('header_click()');
        if(!this.kobetu_mode){
            return false;
        }
        console.log(this.kobetu_mode);
        var masu = document.getElementsByClassName('masu');
        console.log(masu.length);
        var len_masu = masu.length;
        for(var i=0; i<len_masu; i++){
              if(this.all_gray){
                  masu[i].classList.remove('gray');
              }else{
                  masu[i].classList.add('gray');
              }
        }
        this.all_gray = !this.all_gray;
    },

    unit_click(index){
        console.log('unit_click()');
        if(!this.kobetu_mode || index>=5){
            return false;
        }
        console.log(this.kobetu_mode);
        console.log('index', index);
        var masu = document.querySelectorAll('[data-unit="'+index+'"]')
        console.log(masu.length);
        var len_masu = masu.length;
        for(var i=0; i<len_masu; i++){
              if(this.all_gray){
                  masu[i].classList.remove('gray');
              }else{
                  masu[i].classList.add('gray');
              }
        }
        this.all_gray = !this.all_gray;
    },


    startDrag(event, unitno, cellno) {
      console.log('startDrag()');
      this.dragging = true;
      this.x = this.y = 0;
      this.drag_target = unitno+':'+cellno;
      console.log(event.target);
      if( typeof event.target === 'undefined' ){
          return false;
      }
      let is_gray = event.target.classList.contains('gray');
      if(is_gray){
          event.target.classList.remove('gray');
      }else{
          event.target.classList.add('gray');
      }
    },
    doDrag(event, unitno, cellno) {
      if (this.kobetu_mode && this.dragging) {
        console.log('doDrag()');
        console.log('unitno', unitno);
        console.log('cellno', cellno);



        this.x = event.clientX;
        this.y = event.clientY;
        console.log(this.x + ':' + this.y);
        let is_gray = event.target.classList.contains('gray');
        let is_untouchable = event.target.classList.contains('untouchable');
        console.log('gray: ', is_gray);
        console.log('untouchable: ', is_untouchable);

        // UNIT担当者がいないため、ホワイトにできない
        //if(is_untouchable){
        //    return false;
        //}

        // todo
        let this_target = unitno +':'+ cellno;
        if( this.drag_target !== this_target){
            console.log('色変える!');
            this.drag_target = unitno +':'+ cellno;
            if(is_gray){
                event.target.classList.remove('gray');
            }else{
                event.target.classList.add('gray');
            }
        }

      }
    },
    stopDrag() {
      console.log('stopDrag');
      this.dragging = false;
      this.x = this.y = 'no';
    },
    showSyochi(reserve_id, rowIndex){
        console.log('components: showSyochi()');
        console.log('reserve_id', reserve_id);
        console.log('rowIndex', rowIndex);
        this.$emit("do_stop_saibyouga");
        this.$refs.syochiDialog.showDialog(reserve_id, rowIndex);
    },
    showMonshin(reserve_id){
        console.log('components: showMonshin()');
        this.$emit("do_stop_saibyouga");
        this.$refs.monshinDialog.showDialog(reserve_id);
    },
    submit_syochi(data) {
      // 処置内容のデータ飛ばす
      console.log('components: submit_syochi()');
      const path = '/reserve_update/' + data.reserve_id
      axios.post(path, data)
        .then((res) => {
          console.log('処置内容完了');
          console.log(res.data);
          this.$emit("saibyouga", data);
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
        });

    },
    submit_monshin(data) {
      // 問診票のデータ飛ばす
      console.log('components: submit_monshin()');
      const path = '/reserve_update/' + data.reserve_id
      axios.post(path, data)
        .then((res) => {
          console.log('問診票更新完了');
          console.log(res.data);
          this.$emit("saibyouga", 'from_monshin');
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
        });

    },
    setDragenterRow(rowIndex) {
        // どのUNITで操作が行われたか判断
        /*
                <!-- UNIT 1個分 -->
                <div
                  v-for="(row, index) in scheduleData"
                  :key="index"
                  :class="'timeline'"
                  @dragenter="setDragenterRow(index)"
        */
//        console.log('----------');
//        console.log('components: setDragenterRow()');
      this.dragenterRowIndex = rowIndex;
    },

    // こちらは上記のunitDiv版
    /*
                // unitDiv 1マス分
                <div
                  :class="['tl', isBusiness ? 'can-res' : 'cant-res']"
                  :style="{width: width}"
                  @mouseup="mouseup"
                  @dragenter="setDragenterRowAndIndex"
    */
    setDragenterRowAndIndex(rowIndex, currentIndex) {
//        console.log('----------');
//        console.log('components: setDragenterRowAndIndex()');
      this.dragenterRowIndex = rowIndex;
      this.dragenterKeyIndex = currentIndex;
    },
    /**
     * Disable HTML5 DragEnd animation and Set mouse position
     *
     * @param Obejct e Event
     */
    disableDragendAnimation(e) {
      e.preventDefault();
    },
    /**
     * Get header area date-text
     *
     * @param Int n Col index
     *
     * @returns String
     */
    getHeaderDate(n) {
      let startDate = this.addDays(new Date(this.settingData.startDate), n);
      return this.dateFormatter(startDate, true);
    },
    /**
     * Get header area time-text
     *
     * @param {*} n Col index
     */
    getHeaderTime(n) {
      return n % 24;
    },
    /**
     * Get diff day between date1 and date2
     *
     * @param Object date1 DateObejct1
     * @param Object date2 DateObejct2
     *
     * @returns Int
     */
    getDateDiff(date1, date2) {
      const diffTime = Math.abs(date2 - date1);
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    },
    /**
     * Custom date formatter
     *
     * @param Obejct  dateObj     DateObejct
     * @param Boolean withWeekDay If u need weekday, set True
     *
     * @returns String
     */
    dateFormatter(dateObj, withWeekDay) {
      let year = dateObj.getFullYear();
      let month = dateObj.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      let date = dateObj.getDate();
      if (withWeekDay) {
        let day = dateObj.getDay();
        let dayText = this.settingData.weekdayText[day];
        return year + "/" + month + "/" + date + "(" + dayText + ")";
      }
      return year + "/" + month + "/" + date;
    },
    /**
     * Custom datetime formatter
     *
     * @param Obejct  dateObj     DateObejct
     *
     * @returns String
     */
    datetimeFormatter(dateObj) {
      let year = dateObj.getFullYear();
      let month = dateObj.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      let date = dateObj.getDate();
      let hours = dateObj.getHours();
      if (hours < 10) {
        hours = "0" + hours;
      }
      let minutes = dateObj.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      return year + "/" + month + "/" + date + " " + hours + ":" + minutes;
    },
    /**
     * Add days to object
     *
     * @param Obejct dateObj DateObject
     * @param Int    n       Add number
     *
     * @returns Object
     */
    addDays(dateObj, n) {
      dateObj.setTime(dateObj.getTime() + n * 60 * 60 * 24 * 1000);
      return dateObj;
    },
    /**
     * Add minutes to date object
     *
     * @param Obejct dateObj DateObject
     * @param Int    n       Add number
     *
     * @returns Object
     */
    addMinutes(dateObj, n) {
      dateObj.setTime(dateObj.getTime() + n * 60 * 1000);
      return dateObj;
    },
    /**
     * Check this div is business or not
     *
     * @param Int rowIndex Row index
     * @param Int n        Col index
     *
     * @returns Boolean
     */
    isBusiness: function(rowIndex, n) {
      console.log('components: isBusiness()'+ '  unitCnt: '+this.unitCnt, );

      // unitCnt は1UNIT分のマスの数 96. これが、7UNIT分ある.
      // これマスの数だけ呼び出されるから注意
      // 初期表示マスを生成するときにも呼び出される
      // true: 営業, false: 非営業
      /*
      なぜなら,

            <!-- UNIT 1個分 -->
            <div
              v-for="(row, index) in scheduleData"
              :key="index"
              :class="'timeline'"
              :style="{'height': settingData.rowH + 'px'}"
              @dragenter="setDragenterRow(index)"
            >
              <!-- 1個分のマス目 -->
              <unitDiv
                v-for="n in unitCnt"  このnは1から始まる
                :key="'unit' + n"
                :row-index="index"
                :key-index="n"
                :row-data="row"
                :is-business="isBusiness(index, (n - 1))"  nは1から始まるから1引く
      */

      // first check this div business day
      let startDate = new Date(this.settingData.startDate);
      let thisDate = this.addDays(startDate, parseInt(n / this.unitCnt));
//      let noBusinessDate = this.scheduleData[rowIndex].noBusinessDate;
      let noBusinessDate = [];        // 非営業日を決める "2020/04/20"
      if (noBusinessDate.indexOf(this.dateFormatter(thisDate)) >= 0) {
        // today not business day
        return false;
      }

/*
      // and check this div time bussiness hour
      // businessHour を参照してるのはここだけなので、必要があったらorigin参照してください.
      let weekDay = thisDate.getDay();  // 日:0, 月:1, ...,  土：6
      let businessHour = this.scheduleData[rowIndex].businessHours[weekDay];
      if (businessHour.start == "00:00" && businessHour.end == "24:00") {
        // alltime
        return true;
      }
*/
      let businessHour = { start: "00:00", end: "24:00"};

      // has bussiness hour
      // todo: ここもっとシンプルにできそう
      let businessStartTime = businessHour.start.replace(":", "");
      let businessEndTime = businessHour.end.replace(":", "");
      let dateMod = n % this.unitCnt;
      let divStartCnt = dateMod * this.settingData.unit;
      let divStartHour = parseInt(divStartCnt / 60);
      if (divStartHour < 10) {
        divStartHour = "0" + divStartHour;
      }
      let divStartMin = parseInt(divStartCnt % 60);
      if (divStartMin < 10) {
        divStartMin = "0" + divStartMin;
      }
      let divStartTime = divStartHour + "" + divStartMin;
      if (divStartTime >= businessStartTime && divStartTime < businessEndTime) {
        return true;
      }
      return false;
    },

    /**
     * Check this range is business or not
     *
     * @returns Boolean
     */
    isBusinessOnRange(rowIndex, startDateText, endDateText) {
      console.log('----------\n');
      console.log('components: isBusinessOnRange()');
      let startDiff = this.getMinutesDiff(
        new Date(this.settingData.startDate),
        new Date(startDateText)
      );
      let startCnt = parseInt(startDiff / this.settingData.unit);
      let endDiff = this.getMinutesDiff(
        new Date(this.settingData.startDate),
        new Date(endDateText)
      );
      let endCnt = parseInt(endDiff / this.settingData.unit);
      let result = true;
      for (var i = startCnt; i < endCnt; i++) {
        if (!this.isBusiness(rowIndex, i)) {
          result = false;
        }
      }
      return result;
    },
    /**
     * Check this range has other event
     *
     * @param Int    index         Data index
     * @param Int    oldRowIndex   Old row index
     * @param Int    newRowIndex   New row index
     * @param String startDateText StartDate text
     * @param String endDateText   EndDate text
     *
     * @returns Boolean
     */
    hasOtherEvent(index, oldRowIndex, newRowIndex, startDateText, endDateText) {
      for (var n = 0; n < this.scheduleData[newRowIndex].schedule.length; n++) {
        if (n != index || oldRowIndex != newRowIndex) {
          let diffData = this.scheduleData[newRowIndex].schedule[n];
          if (
            new Date(diffData.start) - new Date(startDateText) >= 0 &&
            new Date(diffData.end) - new Date(endDateText) <= 0
          ) {
            return true;
          }
          if (
            new Date(diffData.start) - new Date(startDateText) >= 0 &&
            new Date(diffData.start) - new Date(endDateText) < 0
          ) {
            return true;
          }
          if (
            new Date(diffData.start) - new Date(startDateText) <= 0 &&
            new Date(diffData.end) - new Date(startDateText) > 0
          ) {
            return true;
          }
        }
      }
      return false;
    },
    /**
     * The column are click start event
     *
     * @param Object e Event
     *
     * @returns void
     */
/* eslint-disable */
    selectStartTime(rowIndex, keyIndex) {



      return false;  // todo:
      console.log('----------\n');
      console.log('components: selectStartTime()');
      console.log(rowIndex);
      console.log(keyIndex);

      this.isSelecting = true;
      this.isSelectingRowIndex = rowIndex;
      let addMinutes = (keyIndex - 1) * this.settingData.unit;
      let addMinutes2 = keyIndex * this.settingData.unit;

      let newStartDateObj = this.addMinutes(
        new Date(this.settingData.startDate),
        addMinutes
      );
      let newEndDateObj = this.addMinutes(
        new Date(this.settingData.startDate),
        addMinutes2
      );
      this.scheduleData[rowIndex].schedule.push({
        text: "New",
        start: this.datetimeFormatter(newStartDateObj),
        end: this.datetimeFormatter(newEndDateObj)
      });
      this.isSelectingIndex =
        this.scheduleData[this.isSelectingRowIndex].schedule.length - 1;
    },
/* eslint-disable */
    /**
     * New event adjust event
     *
     * @param int keyIndex
     */
    adjustTimeRange(keyIndex) {
      return false;  // todo:
      console.log('----------\n');
      console.log('components: adjustTimeRange()');
      let targetIndex =
        this.scheduleData[this.isSelectingRowIndex].schedule.length - 1;
      let targetData = this.scheduleData[this.isSelectingRowIndex].schedule[
        targetIndex
      ];
      if (targetData) {
        let addMinutes = keyIndex * this.settingData.unit;
        let newEndDateObj = this.addMinutes(
          new Date(this.settingData.startDate),
          addMinutes
        );
        let newEndDateText = this.datetimeFormatter(newEndDateObj);
        let isPermission = true;

        // Check other event
        if (
          this.hasOtherEvent(
            targetIndex,
            this.isSelectingRowIndex,
            this.isSelectingRowIndex,
            targetData.start,
            newEndDateText
          )
        ) {
          isPermission = false;
        }

        // Check Businessday
        if (isPermission) {
          isPermission = this.isBusinessOnRange(
            this.isSelectingRowIndex,
            targetData.start,
            newEndDateText
          );
        }
        if (isPermission) {
          targetData.end = newEndDateText;
        }
      }
    },
    /**
     * Add new block event
     *
     * @param Boolean isAdd     Is add event action
     * @param String  startDate StartDate text
     * @param String  endDate   EndDate text
     *
     * @returns void
     */
    selectEndTime(unitno, masuno) {
      console.log('----------\n');
      console.log('components: selectEndTime()');
      console.log('unitno: ', unitno);
      console.log('masuno: ', masuno);
      console.log('setting: ', this.setting);


      // todo: 予約詳細で時刻とunitが入力されたまま開く.
      if(this.kobetu_mode){
          this.stopDrag();
          return false;
      }

      this.$router.push({
          name: "reserve",
          params: {'masuno': masuno, 'unitno': unitno, 'startDate': this.setting.startDate.replace(/\//mg, '-')}
          // 受け手側で this.$route.params で取得できる
      }).catch(()=>{});



      return false;

      if (this.isSelecting) {
        if (startDate == undefined) {
          let targetData = this.scheduleData[this.isSelectingRowIndex].schedule[
            this.scheduleData[this.isSelectingRowIndex].schedule.length - 1
          ];
          startDate = targetData.start;
          endDate = targetData.end;
        }
        this.$emit("add-event", this.isSelectingRowIndex, startDate, endDate);
      }
      this.isSelecting = false;
      this.isSelectingRowIndex = null;
      this.isSelectingIndex = null;
      this.clearSwitch = !this.clearSwitch;
    },


    /* eslint-disable */
    moveScheduleData(rowIndex, keyNo, unitCnt) {
        console.log( '----------\ncompontents: moveScheduleData()' );
        console.log('rowIndex: '+rowIndex);  // UNIT番号 0 start
        console.log('keyNo: '+keyNo);        // UNITの中での番号
        console.log('unitCnt: '+unitCnt);    // 左右に何マス分動いたか


      let targetData = this.scheduleData[rowIndex].schedule[keyNo];
      if (targetData) {
        let status = 0;
        let isBusinessFlag = true;
        let isBusinessChecked = false;


        // 関数代入してるだけ
        let changeDatetimeText = (datetimeText) => {
          let addMinutes = unitCnt * this.settingData.unit;
          let dateObj = new Date(datetimeText);
          let newDateObj = this.addMinutes(dateObj, addMinutes);
          return this.datetimeFormatter(newDateObj);
        };


        let newStartDatetime = changeDatetimeText(targetData.start);
        let newEndDatetime = changeDatetimeText(targetData.end);
        console.log('newStartDatetime: '+newStartDatetime);
        console.log('newEndDatetime: '+newEndDatetime);

        if (unitCnt != 0){  // 0でなければ移動発生
          if (
            this.hasOtherEvent(
              keyNo,
              rowIndex,
              this.dragenterRowIndex,
              newStartDatetime,
              newEndDatetime
            )
          ) {
            status = 2;
          } else {
            // ビジネスタイムの範囲にあるか判定
            isBusinessFlag = this.isBusinessOnRange(
              this.dragenterRowIndex,
              newStartDatetime,
              newEndDatetime
            );
            // 正常に移動して良い
            if (isBusinessFlag) {
              // ここで座標変えてる
              targetData.start = newStartDatetime;
              targetData.end = newEndDatetime;
              status = 1;  // 正常に移動できた
            }
            isBusinessChecked = true;
          }
        }

        // UNIT間の移動が発生したか.
        if (
          rowIndex != this.dragenterRowIndex &&
          this.scheduleData[this.dragenterRowIndex]
        ) {
          if (isBusinessChecked && !isBusinessFlag) {
            this.$emit("move-event", status);
            return;
          }
          if (!isBusinessChecked && isBusinessFlag) {
            // 他のイベントと被るか
            if (
              this.hasOtherEvent(
                keyNo,
                rowIndex,
                this.dragenterRowIndex,
                newStartDatetime,
                newEndDatetime
              )
            ) {
              status = 2;
              this.$emit("move-event", status);
              return;
            }
            isBusinessFlag = this.isBusinessOnRange(
              this.dragenterRowIndex,
              targetData.start,
              targetData.end
            );
            isBusinessChecked = true;
          }
          if (isBusinessChecked && isBusinessFlag) {
            // 他のUNITに移動した場合
            this.scheduleData[this.dragenterRowIndex].schedule.push(targetData);
            this.scheduleData[rowIndex].schedule.splice(keyNo, 1);
            status = 1;
          }
        }


        const path = '/reserve_update/' + targetData.id;
        console.log('unit:', targetData.unit);
        console.log('\n--------------------------------------------------\nreserve_update() 呼び出し');
        let unit = ['1', '2', '3', '4', '5', 'A', 'B'][this.dragenterRowIndex]
        axios.post(path, {start: targetData.start, end: targetData.end, unit: unit})
          .then((res) => {
            console.log('ドラッグ&ドロップ完了');
            let yes = confirm('メールを送りますか?')
            console.log('yes', yes);
            if(yes){
                this.$emit("yoyaku_kakunin", targetData);


            }

          })
          .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
          });


        // 通常はここに来る
        this.$emit("move-event", status, targetData.start, targetData.end);
      }
    },  // moveScheduleData
    /* eslint-disable */

    /**
     * Edit Schedule Datetime Text
     *
     * @param int rowIndex  Row
     * @param int keyNo     Key
     * @param int unitCnt   Moved unit count
     *
     * @returns void
     */
    editScheduleData(rowIndex, keyNo, unitCnt) {
      let targetData = this.scheduleData[rowIndex].schedule[keyNo];
      if (targetData) {
        let changeDatetimeText = datetimeText => {
          let addMinutes = unitCnt * this.settingData.unit;
          let dateObj = new Date(datetimeText);
          let newDateObj = this.addMinutes(dateObj, addMinutes);
          return this.datetimeFormatter(newDateObj);
        };
        let newEndText = changeDatetimeText(targetData.end);
        if (
          this.hasOtherEvent(
            keyNo,
            rowIndex,
            rowIndex,
            targetData.start,
            newEndText
          )
        ) {
          return;
        }
        targetData.end = newEndText;
      }
    },
    /**
     * Get minutes diff between date1 and date2
     *
     * @param Object date1 DateObject1
     * @param Object date2 DateObject2
     *
     * @returns Int
     */
    getMinutesDiff(date1, date2) {
      console.log('components: getMinutesDiff()');
      const diffTime = Math.abs(date2 - date1);
      return Math.ceil(diffTime / (1000 * 60));
    }
  }  // components 712~1303
};



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
*{
    box-sizing:border-box;
}
.clear {
  clear: both;
  height: 0;
  line-height: 0;
}

.sc-rows {
  float: left;
  font-weight: bold;
  background: #6187ae;
  border-color: #c0c0c0;
  color: white;
  position: relative;
}

.sc-rows .title {
  background: #6187ae;
}

.sc-rows .sc-rows-scroll {
  position: absolute;
  left: 0;
  top: 0;
}

.sc-main-scroll .sc-time {
  color: #555;
  padding: 0 0;
  line-height: 18px;
  display: block;
  background: #fff;
  border-bottom: dashed 1px LightGray;
  border-right: solid 1px LightGray;
  text-align: center;
  font-size:16px;
  margin-top: -8px;
  height: 148px;
  position: relative;
}
.sc-main-scroll .sc-time-right{
    border-right: none !important;
}
.left_timeline{
    border-top: 2px solid LightGray;
    top: 6px;
    right: 0px;
    display: inline-block;
    width: 10px;
    position: absolute;
}
.left_toptimeline{
    border-top: 3px solid lightgray;
    top: 5px;
}
.right_timeline{
    border-top: 2px solid LightGray;
    top: 6px;
    left: 0px;
    display: inline-block;
    width: 10px;
    position: absolute;
}
.right_toptimeline{
    border-top: 3px solid lightgray;
    top: 5px;
}

.sc-main-box {
  float: left;
  overflow-x: auto;
  overflow-y: auto;
}

.sc-main {
  position: relative;
  height: 800px
}

.timeline {
  position: relative;
}

.sc-bar {
  position: absolute;
  cursor: pointer;
  z-index: 10;
  box-shadow: 2px 2px 4px #333;
  -moz-box-shadow: 2px 2px 4px #333;
  -webkit-box-shadow: 2px 2px 4px #333;
}

.ui-draggable-dragging,
.ui-resizeable {
  z-index: 20;
}

.timeline,
.sc-main .tb {
  border-bottom: solid 2px #666;
}

.sc-rows .timeline {
  overflow: hidden;
}

.sc-rows .timeline span {
  padding: 10px;
  display: block;
}

.sc-rows .timeline span.photo {
  float: left;
  width: 36px;
  height: 36px;
  padding: 10px 0 10px 10px;
}

.sc-rows .timeline span.title {
  float: left;
  padding: 10px 0 10px 10px;
  width: 92px;
}

.sc-main-scroll .sc-main .tl {
/* todo
  float: left;
  height: 100%;
  border-right: solid 1px #ccc;
*/
  border-bottom: dashed 1px LightGray;
}

.sc-main-scroll .sc-main .tl:hover {
  background: #f0f0f0;
}

.cant-res {
  background-color: #999 !important;
}

/deep/ .sc-bar .head {
  display: block;
  padding: 6px 8px 0;
  font-size: 12px;
  height: 16px;
  overflow: hidden;
}

/deep/ .sc-bar .text {
  display: block;
  font-size: 12px;
  padding-left: 5px;
  line-height: 20px;
  min-height: 12px;
  font-weight: normal;
  overflow: hidden;
}

/deep/ .resizable-e {
  cursor: e-resize;
  width: 10px;
  right: -5px;
  top: 0;
  height: 100%;
  z-index: 90;
  position: absolute;
  font-size: 0.1px;
  display: block;
}
.timeline .can-res{
    background: #fff;
}
.disp_none{
    display: none !important;
}
.oneunit{
  border-right: solid 1px LightGray;
}
.scheader{
    border-bottom: solid 3px LightGray;
    height: 40px;
    background: #fff;
}
.scheader .unit_title{
  border-right: solid 1px LightGray;
}
.container{
    padding: 0px !important;
}
/deep/ .icon_block{
    position: absolute;
    right: 4px;
    top: 3px;
}
/deep/ .icon_filter{
    filter: invert(75%) sepia(63%) saturate(428%) hue-rotate(38deg) brightness(87%) contrast(86%) !important;
}
/deep/ span.syochi{
    font-family: "ＭＳ ゴシック", "Courier New", Consolas, monospace !important;
}
/deep/ div.syochi_oya .syochi:hover{
    color: #2196f3;
    border-bottom: 1px solid #2196f3;
}
/deep/ .syochi{
    word-break: break-all;
}
.bBottom_s{
 border-bottom: solid 1px LightGray !important;
}
.bBottom{
    border-bottom: solid 2px LightGray !important;
}
/deep/ .gray{
  background:#ECEDF6 !important;
}
/deep/ .untouchable{
  cursor: not-allowed;
}
/deep/ .clickable{
  cursor: pointer;
}
/deep/ .not_today{
  background: #fff;
  color: #69788A !important;
  border-bottom: solid 2px LightGray;
}
/deep/ .is_past{
    background: #E2E1E1 !important;
}
/deep/ .is_red{
    background: #FFD2D0 !important;
}
/deep/ .patient_name:hover{
    text-decoration: underline;
}
/deep/ .tooltip-container{
    position: relative;
}

/* 名前のツールチップ */
/deep/ .tooltip-text{
    display: none;
    position: absolute;
    z-index: 200;
    background: #ffffff;
    animation: fadeIn 0.3s;
}
@keyframes fadeIn {
 from {
   opacity: 0;
 }
 to {
   opacity: 1;
 }
}

</style>
